export default __webpack_public_path__ + "locales/en/EmptyTrashDialog.json?hash=d9d4dcdbfc3e921421544c3bfe0cfe36";